class AccessDeniedException extends Error {
  constructor(message) {
    super(message);
    this.name = 'AccessDeniedException';
    this.errorStatusCode = 403;
  }
}

export default AccessDeniedException;
